export const tableListaProfili = [
    {accessorKey: "id", header: "ID"},
    {accessorKey: "nazwa", header: "Nazwa instytucji"},
    {accessorKey: "created_at", header: "Utworzono"},];
